module.exports = __webpack_public_path__ + "static/media/integral-icon-2.de19c38e.png";